import { CheckCircle2 } from "lucide-react";

const StatusSuccessAlert = ({resultFile}) => {
  return (
    <div className="mb-4 flex items-center gap-2 rounded-xl border border-[#B9D8D0] bg-[#E9F3F0] px-3.5 py-3 text-sm text-[#204F45]">
      <CheckCircle2 size={18} className="shrink-0" />
      <span>
        فایل پشتیبان با موفقیت ساخته و دانلود شد
        {resultFile ? ` (${resultFile})` : ""}. فایل به‌زودی از سرور حذف می‌شود.
      </span>
    </div>
  );
};

export default StatusSuccessAlert;
